// Changed the Heading and Description Direction based on Language       
document.addEventListener("DOMContentLoaded", function() {
    detectLanguageAndAddClassHeading(".product-meta__title.heading.h3"); 
    detectLanguageAndAddClassDescription(".product-tabs__tab-item-content"); 
    checkShoesCollection();
});

function detectLanguageAndAddClassHeading(selector) {
    const element = document.querySelector(selector);
    if (!element) {
        // console.error("Element not found:", selector);
        return;
    }

    const text = element.textContent.trim();
    console.log("Text to detect:", text);

    // Regex pattern to detect any Hebrew characters
    const hebrewPattern = /[֐-׿]/;

    // Check for Hebrew characters first
    if (hebrewPattern.test(text)) {
        console.log("Text contains Hebrew characters, no class added");
        return;
    }

    // Simple heuristic for detecting English text
    const englishPattern = /^[a-zA-Z0-9\s.,!?'"()-]*$/;

    if (englishPattern.test(text)) {
        document.body.classList.add('english-lang-heading'); 
        console.log("Language is English, class added");
    } else {
        console.log("Text contains non-English characters, no class added");
    }
}

function detectLanguageAndAddClassDescription(descriptionSelector) {
    const descriptionElement = document.querySelector(descriptionSelector);
    if (!descriptionElement) {
        // console.error("Description element not found:", descriptionSelector);
        return;
    }

    const descriptionText = descriptionElement.textContent.trim();
    console.log("Description text to detect:", descriptionText);

    // Regex pattern to detect any Hebrew characters
    const hebrewPattern = /[֐-׿]/;

    // Check for Hebrew characters in description
    if (hebrewPattern.test(descriptionText)) {
        console.log("Description contains Hebrew characters, no class added");
    } else {
        document.body.classList.add('english-lang-description');
        console.log("Description is in English, class added");
    }
}

function checkShoesCollection(){
    
    if (document.querySelectorAll('.product-facet__product-list').length > 0){
        if (document.querySelectorAll('[data-item-category="Shoes"]').length > 0){
            document.body.classList.add('Shoes');
        }

    }

}

// Claude 21 Oct 2026: collab products ("Enterprise Japan × Mr.something EGG Rocket ...") —
// the collab goes in the brand line ("ENTERPRISE JAPAN × MR.SOMETHING") and the name starts with the model,
// so the × no longer jumps to the end of the name on computers.
window.mrsCollab = function (v, t) {
    if (!v || !t || t.getAttribute('data-collab-fixed')) return;
    var name = t.textContent.replace(/\s+/g, ' ').trim();
    var brand = v.textContent.replace(/\s+/g, ' ').trim();
    if (brand && name.toLowerCase().indexOf(brand.toLowerCase() + ' ') === 0) name = name.slice(brand.length + 1);
    var m = name.match(/^[×xX]\s*(Mr\.?\s?something)\s+(.+)$/i);
    if (!m) return;
    t.setAttribute('data-collab-fixed', '1');
    t.textContent = m[2];
    var a = v.querySelector('a') || v;
    if (a.textContent.indexOf('×') === -1) a.textContent = a.textContent.trim() + ' × Mr.something';
};

// Claude 13 Oct 2026: product cards show the brand on its own line (theme setting "Show vendor"),
// so remove the brand from the start of the product name on the card. The full name stays in Shopify
// for Google Shopping / Meta / TikTok feeds.
(function () {
    var ALIASES = { 'mki miyuki zoku': ['MKI'] };
    function fixCards() {
        var metas = document.querySelectorAll('.product-item-meta:not([data-brand-fixed])');
        for (var i = 0; i < metas.length; i++) {
            var m = metas[i];
            m.setAttribute('data-brand-fixed', '1');
            var v = m.querySelector('.product-item-meta__vendor');
            var t = m.querySelector('.product-item-meta__title');
            if (!v || !t) continue;
            var brand = v.textContent.trim();
            var name = t.textContent.trim();
            var prefixes = [brand].concat(ALIASES[brand.toLowerCase()] || []);
            for (var j = 0; j < prefixes.length; j++) {
                var p = prefixes[j];
                if (p && name.toLowerCase().indexOf(p.toLowerCase() + ' ') === 0) {
                    t.textContent = name.slice(p.length + 1);
                    break;
                }
            }
            window.mrsCollab(v, t);
        }
    }
    var queued = false;
    function queue() {
        if (queued) return;
        queued = true;
        (window.requestAnimationFrame || setTimeout)(function () { queued = false; fixCards(); });
    }
    fixCards();
    document.addEventListener('DOMContentLoaded', fixCards);
    if (window.MutationObserver) {
        new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
    }
})();

// Claude 13 Oct 2026: product page polish (brand once, colour row, quiet stock line, no empty tabs, reviews only when they exist)
(function () {
    function stripBrand() {
        var v = document.querySelector('.product-meta__vendor');
        var t = document.querySelector('.product-meta__title');
        if (!v || !t || t.getAttribute('data-brand-fixed')) return;
        t.setAttribute('data-brand-fixed', '1');
        var brand = v.textContent.trim();
        var name = t.textContent.trim();
        var prefixes = [brand].concat(/^mki miyuki zoku$/i.test(brand) ? ['MKI'] : []);
        for (var i = 0; i < prefixes.length; i++) {
            if (name.toLowerCase().indexOf(prefixes[i].toLowerCase() + ' ') === 0) {
                t.textContent = name.slice(prefixes[i].length + 1);
                break;
            }
        }
        window.mrsCollab(v, t);
    }
    // Visually.io moves the size picker out of the form, so put the colour row back above it
    function placeColour() {
        var wrap = document.querySelector('.product-types-wrap');
        var anchor = document.querySelector('.product__info > .product-form__option-info') || document.querySelector('.product__info > product-variants.product-form__variants');
        if (wrap && anchor && wrap.nextElementSibling !== anchor) {
            anchor.parentNode.insertBefore(wrap, anchor);
            window.dispatchEvent(new Event('resize'));
        }
    }
    function colourRow() {
        var wrap = document.querySelector('.product-types-wrap');
        if (!wrap || wrap.getAttribute('data-fixed')) return;
        wrap.setAttribute('data-fixed', '1');
        // drop the product the customer is already on
        wrap.querySelectorAll('.product-types-item').forEach(function (it) {
            if (it.querySelector('a.active')) it.parentNode.removeChild(it);
        });
        if (!wrap.querySelector('.product-types-item')) { wrap.style.display = 'none'; return; }
        var label = wrap.querySelector('.product-types-head .product-form__option-name');
        var title = document.querySelector('.product-meta__title');
        if (label) {
            var m = title ? title.textContent.match(/ in (.+)$/) : null;
            label.innerHTML = 'Colour' + (m ? ': <b>' + m[1].replace(/</g, '') + '</b>' : '');
        }
    }
    function tabs() {
        var box = document.querySelector('.product-form-tabs');
        if (!box || box.getAttribute('data-fixed')) return;
        box.setAttribute('data-fixed', '1');
        var links = box.querySelectorAll('ul.tab-nav li a');
        links.forEach(function (a) {
            var c = box.querySelector(a.getAttribute('href'));
            if (c && !c.textContent.replace(/\s+/g, '') && !c.querySelector('img,iframe,table')) {
                a.parentNode.parentNode.removeChild(a.parentNode);
                c.parentNode.removeChild(c);
            }
        });
        var first = box.querySelector('ul.tab-nav li a');
        if (first && !box.querySelector('ul.tab-nav a.active')) {
            first.classList.add('active');
            var fc = box.querySelector(first.getAttribute('href'));
            if (fc) fc.classList.add('active');
        }
        if (!first) box.style.display = 'none';
    }
    function reviews() {
        var sec = document.querySelector('[id*="yotpo_review_widget"]');
        if (sec && sec.querySelector('.yotpo-review, .yotpo-review-wrapper, [class*="review-card"]')) sec.classList.add('mrs-has-reviews');
    }
    try { var st = document.createElement('style'); st.textContent = '.product-form__option-info{direction:ltr;text-align:left}'; document.head.appendChild(st); } catch (e) {}
    function run() { stripBrand(); colourRow(); placeColour(); tabs(); reviews(); }
    run();
    document.addEventListener('DOMContentLoaded', run);
    var n = 0, iv = setInterval(function () { reviews(); placeColour(); if (++n > 20) clearInterval(iv); }, 500);
})();
